import type { DatePrecisionCode } from './types';

export const MULTIVALUE_FIELDTYPES: readonly string[] = ['MS', 'PD', 'RD', 'CB'];

const DATE_FIELD_TYPES: readonly string[] = ['DT', 'DA', 'YM', 'YO'];

export const isMuliValueFieldType = (fieldType: string): boolean => {
  return MULTIVALUE_FIELDTYPES.includes(fieldType);
};

/** Returns true if the given field type code is one of the backend date types */
export const isDateFieldType = (fieldType: string): boolean => {
  return DATE_FIELD_TYPES.includes(fieldType);
};

/**
 * Resolves the UI field type back to the backend field type.
 * If fieldType is 'DATE', returns the datePrecision value instead.
 * Otherwise returns fieldType as-is.
 */
export const resolveFieldType = (fieldType: string, datePrecision?: string): string => {
  if (fieldType === 'DATE') {
    return datePrecision || 'DA';
  }
  return fieldType;
};

/**
 * Decomposes a backend field type into the UI representation.
 * If the backend type is a date type (DT, DA, YM, YO), returns
 * { fieldType: 'DATE', datePrecision: <the actual type> }.
 * Otherwise returns { fieldType: <as-is>, datePrecision: 'DA' }.
 */
export const decomposeFieldType = (
  backendFieldType: string,
): { fieldType: string; datePrecision: DatePrecisionCode } => {
  if (isDateFieldType(backendFieldType)) {
    return { fieldType: 'DATE', datePrecision: backendFieldType as DatePrecisionCode };
  }
  return { fieldType: backendFieldType, datePrecision: 'DA' };
};

export const insertItemAtIndex = <T>(arr: T[], index: number, value: T): T[] => {
  const newArray = [...arr.slice(0, index), value, ...arr.slice(index + 1)];
  return newArray;
};

export const removeItemAtIndex = <T>(arr: T[], index: number): T[] => {
  return [...arr.slice(0, index), ...arr.slice(index + 1)];
};
